'use strict';

function MortgageDetails() {
  this.node = null;
  this.declaredClass = null;
  this.extends = [_MortgageController];
  this.dataSanitization = new DataSanitization();
  this._tmpAddress = {};

  this.init = function () {
    this._super();
  };

  this.initAllReady = function () {
    this._super();
  };

  this.initPage = function () {
    var _this = this;

    if (this.checkMortgageApplicationEligibility()) {
      this.$node = $(this.node);

      // reorder the elements based off of the type of mortgage
      if (this.presenter.models.mortgage.type !== 'refinance') {
        var lastChild = this.$node.find('.js--reorder-last'); // get the current last child
        var reorder = this.$node.find('.js--reorder-last-otherwise'); // and the new last child
        reorder.insertAfter(lastChild); // then reorder

        reorder.find('input').each(function () {
          var input = $(this);
          if (input.attr('placeholder-alt')) input.mogo().$placeholder.text(input.attr('placeholder-alt')); // update the placeholder
          if (input.data('mogo-ui-error-alt')) {
            input.mogo().error = input.data('mogo-ui-error-alt');
            input.mogo().setError(true, null); // rerender the field error with the new error text
          }
        });
      }

      this._address = {
        address: this.$node.find('[name=address]').mogo(),
        suite: this.$node.find('[name=suite]').mogo(),
        city: this.$node.find('[name=city]').mogo(),
        province: this.$node.find('[name=province]').mogo(),
        postal_code: this.$node.find('[name=postal_code]').mogo()
      };
      this.$closing_date = this.$node.find('[name=closing_date]');
      // set state based on same as applicant checkbox
      this.presenter.addComputedVariable('sameAsApplicant', ['mortgage.address_is_the_same_as_applicant'], function (address_is_the_same_as_applicant) {
        _this._toggleAddressFields(true, address_is_the_same_as_applicant);
      });
      this._toggleAddressFields(false, this.presenter.getModelProperty('mortgage.address_is_the_same_as_applicant'));

      this._extendPresenter();
      this._callback = this.presenter.addCallbackToAction('mortgage.update_mortgage_application', this._onUpdate.bind(this));
      this.presenter.scanDOM();
      // analyitcs
      this.analytics.pushEvent('virtual-page-view');
      this.pushAnalyticsMortgageChoices();
    }

    this._$closingDateCalendar = $('.js--closing-date-calendar');

    this._$closingDateCalendar.mogo().setYearValidation(function (year) {
      var today = moment();
      return today.year() <= year;
    });

    this._$closingDateCalendar.mogo().setMonthValidation(function (year, month) {
      var today = moment();
      return today.year() < year || today.year() === year && today.month() <= month;
    });

    this._$closingDateCalendar.mogo().setDateValidation(function (year, month, date) {
      var today = moment();
      var isBeforeThisYear = today.year() < year;
      var isBeforeThisMonth = today.year() === year && today.month() < month;
      var isBeforeThisDate = today.year() === year && today.month() === month && today.date() < date;
      return isBeforeThisYear || isBeforeThisMonth || isBeforeThisDate;
    });
  };

  this._extendPresenter = function () {
    var setNullable = {
      set: function set(val) {
        if (val) {
          return val;
        }
        return null;
      }
    };

    var clearField = {
      set: function set() {}
    };

    var viewMap = {
      'mortgage.address_is_the_same_as_applicant': {
        set: function (val) {
          // only send address_is_the_same_as_applicant for refinance
          if (this.presenter.models.mortgage.type === 'refinance') return val;
        }.bind(this)
      },

      'mortgage.postal_code': {
        get: function get(value) {
          if (!value || value.length < 1) return value;
          value = value.toUpperCase().replace(' ', '').split('');
          value.splice(3, 0, ' ');
          return value.join('');
        },
        set: function set(value) {
          if (!value || value.length < 1) return value;
          value = value.toUpperCase().replace(' ', '').split('');
          value.splice(3, 0, ' ');
          return value.join('');
        }
      }
    };
    // reset the view map for these properties
    viewMap['mortgage.requested_mortgage_amount'] = {};
    viewMap['mortgage.property_market_value_amount'] = {};

    if (this.presenter.models.mortgage.type === 'pre_approval') {
      viewMap['mortgage.property_market_value_amount'] = clearField;
      viewMap['mortgage.requested_mortgage_amount'] = setNullable;
    } else if (this.presenter.models.mortgage.type !== 'refinance') {
      viewMap['mortgage.requested_mortgage_amount'] = clearField;
    }

    // Extend View map
    this.presenter.extendViewMap(viewMap);

    this.presenter.extendCustomValidations('mortgage.update_mortgage_application', {
      _hooks: { prehook: this._prehook.bind(this) }
    });
  };

  this._prehook = function ($form) {
    var path = this._getValidationPath(this.presenter.getModelProperty('mortgage.type'));

    if (path) {
      var form = this.$node.find('form').mogo();
      form.removeAllValidationPaths();
      form.addValidationIncludePath(path);
    }
  };

  this._getValidationPath = function (type) {
    var path = null;
    switch (type) {
      case 'pre_approval':
        path = '#/oneOf/2/oneOf/0';
        break;
      case 'home_purchase':
        path = '#/oneOf/2/oneOf/1';
        break;
      case 'refinance':
        path = '#/oneOf/2/oneOf/2';
        break;
    }
    return path;
  };

  this._onUpdate = function (data, response) {
    if (response === 200) {
      var formAnalyticsID = this.$node.find('form').data('analytics-id');
      this.analytics.pushEvent('form-submit', { FormID: [formAnalyticsID] });
      this.presenter.updateModel('mortgage', data);
      this._tray().moveNext();
    } else {
      $('#Notification').mogo().get();
    }
  };

  this.destroy = function () {
    this._super();
    this.presenter.resetModels('mortgage');
    this.presenter.removeComputedVariable('sameAsApplicant');
    if (this._callback) this.presenter.removeCallbackFromAction('mortgage.update_mortgage_application', this._callback);
    if (this.$closing_date) this.$closing_date.mogo().destroy();

    this.presenter.extendCustomValidations('mortgage.update_mortgage_application', {
      _hooks: {}
    });
  };

  this._toggleAddressFields = function (isUpdate, address_is_the_same_as_applicant) {
    if (address_is_the_same_as_applicant) {
      if (isUpdate) {
        this._copyAddress();
        this._updateAddress(this.presenter.models.account);
      }
      this._enableAddress(false);
    } else {
      if (isUpdate) this._updateAddress(this._tmpAddress);
      this._enableAddress(true);
    }
  };

  this._enableAddress = function (enabled) {
    $.each(this._address, function (key, item) {
      item.setReadOnly(!enabled);
      if (!enabled) item.hideError();
    });
  };

  this._copyAddress = function () {
    var _this2 = this;

    $.each(this._address, function (key, item) {
      var bind = $(item.node).data('bind');
      _this2._tmpAddress[key] = _this2.presenter.getModelProperty(bind);
    });
  };

  this._updateAddress = function (model) {
    var _this3 = this;

    $.each(this._address, function (key, item) {
      var bind = $(item.node).data('bind');
      _this3.presenter.setModelProperty(bind, model[key]);

      if (key == 'province' && !model[key]) {
        item.setSelectedIndex(0);
      }
    });
  };
}